import { userService } from '../_services';

export const userCustomers = {
    namespaced: true,
    state: {
        all: {},
        active: null,
        ready: false
    },
    actions: {
        getUserCustomers({ commit }) {
            commit('getAllRequest');
            return new Promise((resolve, reject) => {

                userService.getUserCustomers()
                    .then(
                        userLocations => {
                            commit('getAllSuccess', userCustomers);
                            resolve(userLocations);
                        },
                        error => {
                            commit('getAllFailure', error);
                            reject(error);
                        }

                    );
            })
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
            state.active = null;
            state.ready = false;
        },
        getAllSuccess(state, userCustomers) {
            state.all = userCustomers['hydra:member'];
            state.active = null;
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.active = null;
            state.ready = false;
        }
    },
    getters: {
        showUserCustomers(state) {
            return state.all;
        },
        showUserCustomerByIRI(state) {
            return iri => {
                return state.all.find(obj => obj['@id'] === iri)
            }
        },
        showUserCustomersByUser(state) {
            return userid => {
                return state.all.filter(obj => obj.user.id === userid)
            }
        },
        showUserCustomersByUserIRI(state) {
            return useriri => {
                return state.all.filter(obj => obj.user['@id'] === useriri)
            }
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
